import { useDialog } from "@platform/store";
import { MarketingDialogTypes } from "@platform/types/platform.types";
import { MarketingHireUsDialogContainer } from "../../dialogs/HireUsDialog";
import { MarketingNewsletterDialogContainer } from "../../dialogs/NewsletterDialog";
import { MarketingAddYourInstitutionDialogContainer } from "../../dialogs/AddYourInstitutionDialog";
import {
  OrgCodeDialogContainer,
  OrgLookupDialogContainer,
} from "@platform/features/invitation";

export function MarketingDialogsContainer() {
  const { activeDialog } = useDialog();

  if (
    ![
      "code",
      "orgLookup",
      "hireUs",
      "newsletter",
      "addYourInstitution",
    ].includes(activeDialog || "")
  ) {
    return null;
  }

  switch (activeDialog as MarketingDialogTypes) {
    case "code":
      return <OrgCodeDialogContainer />;
    case "orgLookup":
      return <OrgLookupDialogContainer />;
    case "hireUs":
      return <MarketingHireUsDialogContainer />;
    case "newsletter":
      return <MarketingNewsletterDialogContainer />;
    case "addYourInstitution":
      return <MarketingAddYourInstitutionDialogContainer />;
    default:
      return null;
  }
}

